import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import React, { useEffect, useState } from "react";
import styles from "styles.module.css";
import CustomButton from "ui/Button";
import { COLOR, ICON_NAMES } from "utils/constant";
import CustomStepper from "ui/CustomStepper";
import { IRegistrationForm } from "interface/registration";
import FormStepOne from "./form/stepOne";
import FormStepTwo from "./form/stepTwo";
import {
	completeRegistrationApi,
	deleteRegistrationApi,
	registrationEditingDataApi,
	setTemporaryRegistrationStepApi
} from "api/registration";
import { useNavigate, useParams } from "react-router";
import { PageTypePath } from "utils/pages";
import Info from "ui/Info";
import { useTranslation } from "react-i18next";

import OverLayLoading from "ui/Loading";
import { setError, useInfoStore } from "store/error";
import { usePageHeight } from "hooks/hooks";
import { useToastStore } from "store/toast";
import "./styles.css";
const maxStep = 1;

function RegistrationForm() {
	const { t } = useTranslation();

	const [showRequirement, setShowRequirement] = useState(false);
	const [meetRequirement, setMeetRequirement] = useState(false);
	const [formSaved, setFormSaved] = useState(true);
	const [infoData, setInfoData] = useState({
		title: "",
		show: false,
		description: "",
		actions: [{}],
	});
	const [form, setForm] = useState<IRegistrationForm>();
	const router = useNavigate();
	const { id, action } = useParams();
	const [loading, setLoading] = useState(true);
	const stepsItems = [
		{ label: t("CatchInformation"), optional: false },
		{ label: t("ProductLines"), optional: false },
	];
	const [step, setStep] = useState(0);
	const { showWarning } = useToastStore();
	const pageHeight = usePageHeight();
	const [isMobileView, setIsMobileView] = useState(() => window.innerWidth < 768);

	const onSubmit = () => {};

	const handleDelete = () => {
		if (!form?.id) {
			return;
		}
		deleteRegistrationApi(form?.id)
			.then((response) => {
				router(`/${PageTypePath.RegistrationList}`);
			})
			.catch((error) => {
				setInfoData({
					show: true,
					title: "Slett Error",
					description: "En feil oppstod",
					actions: [
						{ text: "Avbryt", btn: resetInfoData },

						{
							text: "Ok",
							btn: resetInfoData,
						},
					],
				});
			});
	};

	const handleFinish = () => {
		if (!meetRequirement) {
			if ((!form?.lines || form.lines.length === 0) && form?.noteType !== 1) {
				showWarning(t("LinesRequired"), {
					duration: 6000,
					pauseOnHover: true,
					style: {
						paddingTop: 30,
						paddingBottom: 30,
					},
					position: "bottom-center",
				});
				return;
			}
			setShowRequirement(true);
			return;
		}
		completeRegistrationApi(id as any)
			.then((data) => {
				let navigateTo = `/${PageTypePath.RegistrationList}`;
				try {
					if (data.data.noteType === 1 && data.data.noteHeadId !== 0) {
						navigateTo = `/${PageTypePath.LandingNoteForm}/${data.data.noteHeadId}`;
					}
				} catch {}

				setInfoData({
					show: true,
					title: t("Completed"),
					description: t("RegistrationCompleted"),
					actions: [
						{
							text: "Ok",
							btn: () => {
								resetInfoData();
								router(navigateTo);
							},
						},
					],
				});
			})
			.catch((err) => {
				if (err?.response?.data) {
					setError(err?.response?.data.returnText);
				} else {
					setError(err.message);
				}
			});
	};

	const handleNext = () => {
		if (!meetRequirement) {
			setShowRequirement(true);
			return;
		}


		if (form?.terminalId) {
			setStep(maxStep);
		} else {
			let nextStep = step + 1;

			setStep(nextStep);

			if (form !== undefined) {
				if (form.currentStep <= nextStep) {
					setTemporaryRegistrationStepApi(form.id, nextStep)
						.then((response) => { })
						.catch((err) => {
							console.log(err);
							if (err?.response?.data) {
								setError(err?.response?.data.returnText);
							} else {
							 setError(err.message);
							}
						});
					form.currentStep = nextStep;

					router(`/${PageTypePath.RegistrationForm}/${id}/${nextStep}`);
				}
			}
		}
		setShowRequirement(false);
	};

	const handlePrevious = () => {
		let nextStep = step - 1;

		setStep(nextStep);

		if (form !== undefined) {
			if (form.currentStep >= nextStep) {
				setTemporaryRegistrationStepApi(form.id, nextStep)
					.then((response) => { })
					.catch((err) => {
						console.log(err);
						if (err?.response?.data) {
							setError(err?.response?.data.returnText);
						} else {
							setError(err.message);
						}
					});
				form.currentStep = nextStep;

				router(`/${PageTypePath.RegistrationForm}/${id}/${nextStep}`);
			}
		}
	};
	useEffect(() => {
		if (!action) {
			return;
		}
		const _step = parseInt(action);
		if (!Number.isNaN(_step) && _step <= maxStep && _step !== 0) {
			setStep(_step);
		}
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth < 768);
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (form || !id) {
			setLoading(false);
			return;
		}
		registrationEditingDataApi(id as any)
			.then((response) => {
				if (response.data.lines) {
					response.data.lines = response.data.lines.map((line) => ({
						...line,
						inEdit: true,
					}));
				}

				setForm(response.data);
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	const confirmDelete = () => {
		setInfoData({
			show: true,
			title: "Slett innmelding",
			description: "Er du sikker du vil slette innmelding",
			actions: [
				{ text: "Avbryt", btn: resetInfoData },

				{
					text: "Ok",
					btn: handleDelete,
					bgColor: "red",
					textColor: "white",
				},
			],
		});
	};
	const resetInfoData = () => {
		setInfoData({
			show: false,
			title: "",
			description: "",
			actions: [],
		});
	};
	const handleStepClick = (step: number) => {
		if (step === maxStep) {
			return;
		}
		if (!meetRequirement) {
			setShowRequirement(true);
			return;
		}
		setStep(step);
	};
	if (loading && !form) return <OverLayLoading />;

	return (
		<div className={`${styles.PageContainer} registration-page`} style={{ height: "100%" }}>
			<legend
				className={styles.BoxHeadingLarge}
				style={{ paddingBottom: "20px" }}
			>
				{t("NewRegistration")}
			</legend>
			<CustomStepper
				className="registration-stepper"
				steps={stepsItems}
				activeStep={step}
				setActiveStep={handleStepClick}
			/>
			<div
				className="registration-content"
				style={{
					display: "flex",
					flexDirection: "column",
					height: isMobileView ? "auto" : pageHeight - 400,
					maxHeight: isMobileView ? "none" : `calc(${pageHeight}px - 300px)`,
					justifyContent: "space-between",
					gap: isMobileView ? "16px" : "0px",
				}}
			>
				<div
					style={{
						minHeight: isMobileView ? "calc(100dvh - 320px)" : undefined,
						overflow: "auto",
					}}
				>
					<Form
						onSubmit={onSubmit}
						render={(formRenderProps: FormRenderProps) => (
							<FormElement className="registration-form-element" style={{ width: "100%" }}>
								<fieldset className={"k-form-fieldset"}>
									{step === 0 && (
										<FormStepOne
											form={form as any}
											setFormSaved={setFormSaved}
											setStep={setStep}
											setForm={setForm}
											showRequirement={showRequirement}
											setMeetRequirement={setMeetRequirement}
										/>
									)}
									{step === 1 && (
										<FormStepTwo
											form={form as any}
											setForm={setForm as any}
											showRequirement={showRequirement}
											setMeetRequirement={setMeetRequirement}
										/>
									)}
								</fieldset>
							</FormElement>
						)}
					/>
				</div>

				<div style={{}}>
					<div
						className="registration-actions-row"
						style={{
							display: "flex",
							justifyContent: "space-between",
							flexDirection: isMobileView ? "column" : "row",
							gap: isMobileView ? "12px" : "0px",
							flex: 1,
						}}
					>
						<div className="registration-actions-left" style={{ display: "flex", gap: "10px" }}>
							<CustomButton
								onClick={confirmDelete}
								label={t("DeleteTemporaryData")}
								iconName={ICON_NAMES.Delete}
								btnStyle={isMobileView ? { width: "100%" } : undefined}
							/>

							<div className="registration-saved-indicator" style={{ display: "flex", gap: "10px" }}>
								<span style={{ paddingTop: "7px" }} className={styles.TableText}>
									{t("AllChangesSaved")}
								</span>
								<span style={{ paddingTop: "7px" }}>
									<img
										src={`/icon/${
											formSaved ? "checkmark_green" : ICON_NAMES.Checkbox
										}.svg`}
										alt={"complete icon"}
									/>
								</span>
							</div>
						</div>

						<div className="registration-actions-right" style={{ display: "flex", gap: "10px" }}>
							{step > 0 && (
								<CustomButton
									onClick={handlePrevious}
									label={t("Previous")}
									iconName={ICON_NAMES.Prevous}
									iconRight={false}
									btnStyle={isMobileView ? { width: "100%" } : undefined}
								/>
							)}

							{(step === maxStep || form?.noteType === 1) && (
								<>
									<CustomButton
										onClick={handleFinish}
										label={t("Complete")}
										bgColor={COLOR.Green}
										color={"white"}
										iconName={ICON_NAMES.FinishTransparent}
										btnStyle={isMobileView ? { width: "100%" } : undefined}
									/>
								</>
							)}

							{step < maxStep && form?.noteType === 0 && (
								<CustomButton
									onClick={handleNext}
									label={t("Next")}
									bgColor={COLOR.Green}
									color={"white"}
									iconName={ICON_NAMES.NextWhite}
									btnStyle={isMobileView ? { width: "100%" } : undefined}
								/>
							)}
						</div>
					</div>
					<Info
						close={resetInfoData}
						title={infoData.title}
						show={infoData.show}
						description={infoData.description}
						actions={infoData.actions as any}
					/>
				</div>
			</div>
		</div>
	);
}

export default RegistrationForm;
